import React from "react";

export default class ChatBox extends React.Component {
  render() {
    return (
      <div className="ChatBox">

        <div className="input-group input-group-lg">
          <input name='user_name' onChange={this.props.onTextChange} className="ChatBox-profile name form-control"  placeholder="名前" />
          <input name='profile_image' onChange={this.props.onTextChange} className="ChatBox-profile image form-control" placeholder="プロフィール画像URL" />
        </div>

        <textarea name='text' className="ChatBox-textarea form-control" onChange={this.props.onTextChange} />
        <button className="ChatBox-button" onClick={this.props.onButtonClick}>送信</button>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/chatBox.js
 **/